import Sidebar from "../../../components/partials/Sidebar";
import Header from "../../../components/partials/Header";
import Breadcrumb from "../../../components/Breadcrumb";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Pagination from "../../../components/Pagination";
import "./style.css";
import filter from "../../../images/icons/filter.png";
import editIcon from "../../../images/icons/edit.png";
import Tippy from "@tippyjs/react";
import "tippy.js/dist/tippy.css";
import Modal from "react-bootstrap/Modal";
import viewIcon from "../../../images/view.png";
import ItemCatViews from "./view";
import ItemCatAdd from "./Add";
import ItemCatEdit from "./Edit";
import {
  apiCancelItem,
  apiCancelItemCat,
  apiListBranch,
  apiListGodown,
  apiListItem,
  apiListItemCat,
  apiListPltCommon,
} from "../../../api/master";
import Swal from "sweetalert2";
import { inputAlphanumSpe, removeEmptyFields } from "../../../utils";
import BulkUpload from "./BulkUpload";

function ItemCatList() {
  const initialState = {
    item_name: "",
    item_cat_id: "",
    is_active: "",
  };
  const [allBranch, setAllBranch] = useState([]);
  const [allGodown, setAllGodown] = useState([]);
  const [itemCatList, setItemCatList] = useState([]);

  async function ItemGodowList() {
    const payload = { paginate: 0, is_active: 1 };
    await apiListGodown(payload).then((result) =>
      setAllGodown(result.data.data.list),
    );
  }
  async function ItemBranchList() {
    const payload = { paginate: 0, is_active: 1 };
    await apiListBranch(payload).then((result) =>
      setAllBranch(result.data.data.list),
    );
  }
  async function ItemCatList() {
    const payload = { paginate: 0, is_active: 1 };
    await apiListItemCat(payload).then((result) =>
      setItemCatList(result.data.data.list),
    );
  }
  useEffect(function () {
    ItemGodowList();
    ItemBranchList();
    ItemCatList();
  }, []);
  const [user, setUser] = useState({});

  const [itemUnitList, setItemUnitList] = useState([]);
  useEffect(() => {
    apiListPltCommon({ paginate: 0, is_active: 1 })
      .then((res) => {
        let uomList = [];
        for (let i = 0; i < res.data.data?.list.length; i++) {
          if (res.data.data?.list[i].plt_name == "item_uom") {
            uomList.push({
              value: res.data.data?.list[i].plt_disp_val,
              label: res.data.data?.list[i].plt_val,
            });
          }
        }
        setItemUnitList(() => uomList);
      })
      .catch(() => { });
  }, []);

  useEffect(function () {
    if (localStorage.getItem("inventory")) {
      setUser(JSON.parse(localStorage.getItem("inventory")).userData);
    }
  }, []);

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  // excel
  const [showExcel, setShowExcel] = useState(false);
  const handleCloseExcel = () => setShowExcel(false);
  const handleShowExcel = () => setShowExcel(true);

  const [showId, setShowId] = useState(0);
  const [editId, setEditId] = useState("");

  const [formInputs, setFormInputs] = useState(initialState);
  const [filtersVisible, setFiltersVisible] = useState(false);

  const [list, setList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isSubmit, setIsSubmit] = useState(false);
  const [error, setError] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPage, setTotalPage] = useState(0);
  const [isOpen, setIsOpen] = useState(false);

  async function changeStatus(item_id, status) {
    let target = window.event.target;
    let oldText = target.innerText;
    target.innerText = "Updating...";
    await apiCancelItem({ item_id: item_id, is_active: status })
      .then((data) => {
        setError("");
      })
      .catch((err) => {
        setError(err.response.data.data.message);
        setTimeout(function () {
          setError("");
        }, 3000);
      })
      .finally(() => {
        target.innerText = oldText;
        getList(filtersVisible);
      });
  }

  async function getList(isFilter = true, pageNo = null) {
    let json = { paginate: 1, page_no: (pageNo || currentPage) - 1 };
    if (isFilter) {
      json = { ...json, ...formInputs };
      json = JSON.parse(
        JSON.stringify(json, (_, v) => (v === "" ? undefined : v)),
      );
    }
    json = removeEmptyFields(json);
    await apiListItem(json)
      .then((data) => {
        setCurrentPage(pageNo || currentPage);
        setIsSubmit(false);
        setList(data.data.data.list);
        setIsLoading(false);
        setTotalPage(data.data.data.count);
      })
      .catch(function (err) {
        setIsSubmit(false);

        Swal.fire({
          icon: "error",
          title: "Error",
          text: err.response.data.data.message,
          confirmButtonText: "OK",
          allowEnterKey: false,
          allowEscapeKey: false,
          allowOutsideClick: false,
          focusConfirm: true,
        });
      });
  }

  useEffect(
    function () {
      getList(filtersVisible);
    },
    [currentPage],
  );

  function handleInputs(e) {
    setFormInputs({ ...formInputs, [e.target.id]: e.target.value });
  }

  function handleFilterVisibility() {
    if (filtersVisible) {
      setFiltersVisible(false);
      setFormInputs(initialState);
    } else {
      setFiltersVisible(true);
    }
  }

  return (
    <>
      <div
        className="d-flex min-vh-100 main-Wrapper"
        style={{ background: "#DAE5FF" }}
      >
        <Sidebar />
        <div className="content m-1  p-2">
          <Header />
          <main className="bg-white rounded-4" id="buyer">
            <div className="container-fluid p-2">
              <div className="row">
                <div className="col">
                  <Breadcrumb path={["Item"]} />
                </div>
                <div
                  className="col text-end"
                  style={{
                    display: "flex",
                    alignItems: "end",
                    justifyContent: "end",
                  }}
                >
                  <Tippy content="Filter">
                    <img
                      onClick={() => handleFilterVisibility()}
                      src={filter}
                      className="img-fluid me-3"
                      alt=""
                      role="button"
                      style={{ width: "2rem" }}
                    />
                  </Tippy>
                  {user.role_id === 3 || user.role_id === 4 ? (
                    ""
                  ) : (
                    // <Link
                    //   onClick={(v) => {
                    //     handleShow();
                    //     setShowId(1);
                    //   }}
                    // >
                    <button
                      className="btn btn-secondary rounded-3 "
                      type="button"
                      style={{
                        height: "33px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        marginRight: "10px",
                      }}
                      onClick={() => {
                        // setIsOpen(true);
                        handleShow();
                        setShowId(4);

                        // setModalType("uploadExcel");
                      }}
                    >
                      Upload Excel
                    </button>
                    // </Link>
                  )}
                  {user.role_id === 3 || user.role_id === 4 ? (
                    ""
                  ) : (
                    <Link
                      onClick={(v) => {
                        handleShow();
                        setShowId(1);
                      }}
                      className="btn btn-primary px-4 py-2"
                      style={{
                        height: "33px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      Add Item
                    </Link>
                  )}
                </div>
              </div>

              {filtersVisible && (
                <form
                  onSubmit={(e) => {
                    e.preventDefault();
                    setIsSubmit(true);
                    currentPage > 1 ? setCurrentPage(1) : getList(true, 1);
                  }}
                  autoComplete="off"
                >
                  <div className="row" id="buyerAdd">
                    <div className="col-md">
                      <label htmlFor="item_name">Item Name</label>
                      <input
                        type="text"
                        className="form-control"
                        id="item_name"
                        onKeyDown={inputAlphanumSpe}
                        value={formInputs.item_name}
                        onChange={handleInputs}
                      />
                    </div>
                    <div className="col-md">
                      <label htmlFor="item_cat_id">Item Category</label>
                      <select
                        className="form-select"
                        id="item_cat_id"
                        value={formInputs.item_cat_id}
                        onChange={handleInputs}
                      >
                        <option value="">All</option>
                        {itemCatList.map((item) => (
                          <option
                            key={item.item_cat_id}
                            value={item.item_cat_id}
                          >
                            {item.item_cat_name}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="col-md">
                      <label htmlFor="is_active">Status</label>
                      <select
                        className="form-select"
                        value={formInputs.is_active}
                        onChange={handleInputs}
                        id="is_active"
                      >
                        <option value="">All</option>
                        <option value="1">Active</option>
                        <option value="0">In-Active</option>
                      </select>
                    </div>
                    <div
                      className="col-md-4 mt-auto"
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "end",
                        float: "right",
                      }}
                    >
                      <button
                        className="btn btn-primary"
                        type="submit"
                        disabled={isSubmit}
                        style={{
                          height: "33px",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          float: "right",
                        }}
                      >
                        {isSubmit && (
                          <span className="spinner-border spinner-border-sm me-2"></span>
                        )}
                        Search
                      </button>
                      <button
                        className="btn btn-primary rounded-3 px-3 ms-2"
                        type="button"
                        onClick={(e) => {
                          setFormInputs(initialState);
                          currentPage > 1
                            ? setCurrentPage(1)
                            : getList(false, 1);
                        }}
                        style={{
                          background: "#4263eb",
                          fontSize: "14px",
                          height: "33px",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          float: "right",
                        }}
                      >
                        Clear Filters
                      </button>
                    </div>
                  </div>
                </form>
              )}

              {error && (
                <div className="row mt-3">
                  <div className="col">
                    <div
                      className={`alert alert-danger py-1 small`}
                      role="alert"
                    >
                      {error || ""}
                    </div>
                  </div>
                </div>
              )}

              <div className="row mb-4">
                <div className="col">
                  <table className={`table ${error ? "my-1" : "mt-4"} rounded`}>
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Item Name</th>
                        <th>Item Category</th>
                        <th>Description</th>
                        <th>Base Uom</th>
                        <th className="text-end">Max Price</th>
                        <th>Status</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {(isLoading || list.length == 0) && (
                        <tr>
                          <td colSpan="9" className="text-center">
                            {isLoading ? "Loading..." : "No Records"}
                          </td>
                        </tr>
                      )}
                      {list.map((v, i) => (
                        <tr key={`bl_` + i}>
                          <td>{currentPage * 10 - 10 + i + 1}</td>
                          <td>
                            <span title={v?.item_name}>
                              {v?.item_name?.substring(0, 50)}{" "}
                              {v?.item_name?.length > 49 ? "..." : ""}
                            </span>
                          </td>
                          <td>
                            <span title={v?.item_cat_name}>
                              {v?.item_cat_name?.substring(0, 50)}{" "}
                              {v?.item_cat_name?.length > 49 ? "..." : ""}
                            </span>
                          </td>
                          <td>
                            <span title={v?.item_desc}>
                              {v?.item_desc?.substring(0, 40)}{" "}
                              {v?.item_desc?.length > 39 ? "..." : ""}
                            </span>
                          </td>
                          <td>{v?.item_unit}</td>
                          <td className="text-end">{v?.item_price}</td>
                          {/* <td>
                            <span title={v?.item_godown_name}>
                              {v?.item_godown_name?.substring(0, 20)}{" "}
                              {v?.item_godown_name?.length > 19 ? "..." : ""}
                            </span>
                          </td> */}
                          {/* <td >{v.avail_stock}</td> */}
                          <td>
                            {user.role_id === 3 || user.role_id === 4 ? (
                              <Tippy disabled>
                                {v.is_active ? (
                                  <span
                                    className="badge text-bg-success"
                                    role="button"
                                  >
                                    Active
                                  </span>
                                ) : (
                                  <span
                                    className="badge text-bg-danger"
                                    role="button"
                                  >
                                    In-Active
                                  </span>
                                )}
                              </Tippy>
                            ) : (
                              <Tippy content="Change Status">
                                {v.is_active ? (
                                  <span
                                    className="badge text-bg-success"
                                    role="button"
                                    onClick={() => changeStatus(v.item_id, 0)}
                                  >
                                    Active
                                  </span>
                                ) : (
                                  <span
                                    className="badge text-bg-danger"
                                    role="button"
                                    onClick={() => changeStatus(v.item_id, 1)}
                                  >
                                    In-Active
                                  </span>
                                )}
                              </Tippy>
                            )}
                          </td>
                          <td>
                            <Tippy content="View" trigger="mouseenter">
                              <a
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                  setEditId(v);
                                  handleShow();
                                  setShowId(3);
                                }}
                              >
                                <img
                                  src={viewIcon}
                                  className="img-fluid me-2"
                                  alt=""
                                />
                              </a>
                            </Tippy>

                            {user.role_id === 3 || user.role_id === 4 ? (
                              ""
                            ) : (
                              <Tippy content="Edit" trigger="mouseenter">
                                <Link
                                  onClick={() => {
                                    setEditId(v);
                                    handleShow();
                                    setShowId(2);
                                  }}
                                  className={`link-info ${v.is_active ? "" : "d-none"
                                    }`}
                                >
                                  <img
                                    src={editIcon}
                                    className="img-fluid me-2"
                                    alt=""
                                  />
                                </Link>
                              </Tippy>
                            )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>

              <div className="row">
                <div className="col">
                  <Pagination
                    nPages={Math.ceil(totalPage / 10)}
                    currentPage={currentPage}
                    setCurrentPage={setCurrentPage}
                  />
                </div>
              </div>
              <Modal
                show={show}
                onHide={handleClose}
                keyboard={false}
                backdrop="static"
                size="lg"
              >
                {showId == 1 ? (
                  <ItemCatAdd
                    id={editId}
                    itemUnitList={itemUnitList}
                    list={getList}
                    hide={handleClose}
                    allBranch={allBranch}
                    allGodown={allGodown}
                    allItemCat={itemCatList}
                  />
                ) : showId == 2 ? (
                  <ItemCatEdit
                    id={editId}
                    itemUnitList={itemUnitList}
                    list={getList}
                    hide={handleClose}
                    allBranch={allBranch}
                    allGodown={allGodown}
                    allItemCat={itemCatList}
                  />
                ) : showId == 3 ? (
                  <ItemCatViews
                    id={editId}
                    itemUnitList={itemUnitList}
                    list={getList}
                    hide={handleClose}
                    allBranch={allBranch}
                    allGodown={allGodown}
                    allItemCat={itemCatList}
                  />
                ) : showId == 4 ? (
                  <BulkUpload
                    // id={editId}
                    itemUnitList={itemUnitList}
                    list={getList}
                    hide={handleClose}
                  />
                ) : null}
              </Modal>
            </div>
          </main>
        </div>
      </div>
    </>
  );
}

export default ItemCatList;
